import { render, staticRenderFns } from "./StructureNameField.vue?vue&type=template&id=406b79d2&scoped=true&"
import script from "./StructureNameField.vue?vue&type=script&lang=ts&"
export * from "./StructureNameField.vue?vue&type=script&lang=ts&"
import style0 from "./StructureNameField.vue?vue&type=style&index=0&id=406b79d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b79d2",
  null
  
)

export default component.exports